if (!customElements.get('olvaxin-lazy-video')) {
  customElements.define('olvaxin-lazy-video', class extends HTMLElement {
    static get observedAttributes() { return ['data-active']; }
    connectedCallback() {
      this.onVisibility = () => this.sync();
      this.onPageHide = () => this.release();
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.1;
        this.sync();
      }, { threshold: [0, 0.1] });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('pagehide', this.onPageHide);
      window.addEventListener('pageshow', this.onVisibility);
    }
    attributeChangedCallback() { this.sync(); }
    sync() {
      const active = !this.hasAttribute('data-manual') || this.hasAttribute('data-active');
      if (!this.isConnected || !this.inView || !active || document.hidden) {
        this.release();
        return;
      }
      if (this.video) return;
      this.video = this.querySelector('template').content.querySelector('video').cloneNode(true);
      this.video.muted = true;
      this.append(this.video);
      this.video.play().catch(() => {});
    }
    release() {
      if (!this.video) return;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      this.video.load();
      this.video.remove();
      this.video = null;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('pagehide', this.onPageHide);
      window.removeEventListener('pageshow', this.onVisibility);
      this.release();
    }
  });
}
